<template>
    <div id="ComponentModalRegistroItem">
        <div class="modal fade modern-modal" id="ModalRegistroItem" tabindex="-1" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            :disabled="loading"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2> 
                                Detalhes do Item
                                <span v-if="itemInfo.cdReferencia" class="ms-2 text-muted">#{{ itemInfo.cdReferencia }}</span>
                            </h2>
                            <p v-if="itemInfo.nmItem || itemInfo.cdReferencia || itemInfo.cdItem || itemInfo.tpItem">
                                <strong>{{ itemInfo.nmItem || '-' }}</strong>
                                <span v-if="itemInfo.cdReferencia"> • Ref: {{ itemInfo.cdReferencia }}</span>
                                <span v-if="itemInfo.tpItem"> • {{ itemInfo.tpItem }}</span>
                            </p>
                        </div>
                        <div class="header-status">
                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="total-chip">Quantidade total: <b>{{ formatarQtd(qtdTotalItem) }}</b></span>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="section-stack">
                            <div class="section-card">
                                <div class="dependency-toolbar">
                                    <div class="toolbar-text">
                                        Busque por <strong>nome do registro</strong>.
                                    </div>
                                    <div class="toolbar-actions">
                                        <div class="input-group modern-input" style="max-width: 340px;">
                                            <span class="input-group-text">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                    <path d="M21 21L16.65 16.65M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                            <input type="text"
                                                   class="form-control"
                                                   v-model="filter"
                                                   placeholder="Buscar..." />
                                        </div>
                                    </div>
                                </div>

                                <div class="table-wrapper modern-table">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th style="white-space: nowrap;">Registro</th>
                                                <th style="white-space: nowrap; width: 10%;">Setor</th>
                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Qtd</th>
                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Utilizado</th>
                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Ativo</th>
                                                <th class="text-center" style="white-space: nowrap; width: 1%;">Inclusão</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, i) in itensFiltrados" :key="row.idRegistroNecessidadeItem || i">
                                                <td data-label="Registro">
                                                    <div>
                                                        <b>{{ row.nmRegistroNecessidade || ('Registro ' + row.idRegistroNecessidade) }}</b>
                                                    </div>
                                                    <div class="text-muted" v-if="row.dsRegistroNecessidade">
                                                        {{ row.dsRegistroNecessidade }}
                                                    </div>
                                                    <div class="text-muted mt-1" v-if="row.qtdTotalPorRegistro !== null && row.qtdTotalPorRegistro !== undefined">
                                                        Total do registro: <b>{{ formatarQtd(row.qtdTotalPorRegistro) }}</b>
                                                    </div>
                                                </td>
                                                <td data-label="Setor">
                                                    <b>{{ row.nmSetorItem}}</b>
                                                </td>
                                                <td data-label="Qtd" class="text-center">
                                                    <span class="number-badge">{{ formatarQtd(row.qtdItem) }}</span>
                                                </td>
                                                <td data-label="Utilizado" class="text-center">
                                                    <span :class="['pill', row.flUtilizado ? 'pill-ok' : 'pill-warn']">
                                                        {{ row.flUtilizado ? 'Sim' : 'Não' }}
                                                    </span>
                                                </td>
                                                <td data-label="Ativo" class="text-center">
                                                    <span :class="['pill', row.flAtivo ? 'pill-ok' : 'pill-off']">
                                                        {{ row.flAtivo ? 'Sim' : 'Não' }}
                                                    </span>
                                                </td>
                                                <td data-label="Inclusão" class="text-center">{{ formatarData(row.dtInclusao) }}</td>
                                            </tr>

                                            <tr v-if="!loading && itensFiltrados.length === 0">
                                                <td colspan="5" class="empty-state"> 
                                                    <div class="empty-content">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                            <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                                            <circle cx="8" cy="4.5" r="1" />
                                                        </svg>
                                                        <h3 class="empty-title">Nada encontrado</h3>
                                                        <p class="empty-description">Tente ajustar o filtro.</p>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr v-if="loading">
                                                <td colspan="5" class="empty-state">
                                                    <div class="empty-content">
                                                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        <h3 class="empty-title">Carregando...</h3>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div class="custom-table-footer">
                                    <div class="pagination-controls">
                                        <span @click="previousPage" :class="['page-box', { disabled: page === 0 || loading }]">
                                            <span class="navigation-symbol">«</span>
                                        </span>
                                        <span v-for="p in pagesToShow"
                                              :key="p"
                                              @click="goToPage(p)"
                                              :class="['page-box', { 'page-box-active': p === page, disabled: loading }]">
                                            {{ p + 1 }}
                                        </span>
                                        <span @click="nextPage" :class="['page-box', { disabled: !temProximaPagina || loading }]">
                                            <span class="navigation-symbol">»</span>
                                        </span>
                                    </div>
                                    <span class="footer-total">Registros encontrados: <b>{{ qtdRecords }}</b></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <div class="footer-actions">
                            <button type="button"
                                    class="modern-btn modern-btn-secondary"
                                    data-bs-dismiss="modal">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalRegistroItem',

        data() {
            return {
                bsModal: null,
                itemInfo: {
                    idItem: null, 
                    nmItem: null,
                    cdReferencia: null,
                    cdItem: null,
                    tpItem: null,
                },
                loading: false,
                rows: [],
                qtdRecords: 0,
                filter: '',
                page: 0,
                pageSize: 10,
                qtdTotalItem: 0,
                qtdRegistros: 0,
                idRegistroNecessidadeFiltro: null,
            }
        },

        computed: {
            itensFiltrados() {
                const termo = (this.filter || '').trim().toLowerCase()
                if (!termo) return this.rows

                return this.rows.filter(x => {
                    const a = String(x.idRegistroNecessidadeItem ?? '').toLowerCase()
                    const b = String(x.idRegistroNecessidade ?? '').toLowerCase()
                    const c = String(x.nmRegistroNecessidade ?? '').toLowerCase()
                    const d = String(x.dsRegistroNecessidade ?? '').toLowerCase()
                    return a.includes(termo) || b.includes(termo) || c.includes(termo) || d.includes(termo)
                })
            },

            totalPages() {
                return Math.max(1, Math.ceil((this.qtdRecords || 0) / this.pageSize))
            },

            temProximaPagina() {
                return (this.page + 1) < this.totalPages
            },

            pagesToShow() {
                const maxPages = 5
                const pages = []
                let start = Math.max(this.page - 2, 0)
                let end = Math.min(start + maxPages, this.totalPages)
                if (end - start < maxPages) start = Math.max(end - maxPages, 0)
                for (let i = start; i < end; i++) pages.push(i)
                return pages
            },
        },

        mounted() {
            const el = document.getElementById('ModalRegistroItem')
            const bs = window.bootstrap || window.Bootstrap
            if (el && bs?.Modal) {
                this.bsModal = new bs.Modal(el)
            }
            if (el) {
                el.addEventListener('hidden.bs.modal', this.onModalHidden)
            }
        },

        beforeUnmount() {
            const el = document.getElementById('ModalRegistroItem')
            if (el) {
                el.removeEventListener('hidden.bs.modal', this.onModalHidden)
            }
        },

        methods: {
            onModalHidden() {
                this.filter = ''
                this.page = 0
                this.rows = []
                this.qtdRecords = 0
                this.qtdTotalItem = 0
                this.qtdRegistros = 0
            },

            abrir(item) {
                this.itemInfo = {
                    idItem: item?.idItem ?? null,
                    nmItem: item?.nmItem ?? null,
                    cdReferencia: item?.cdReferencia ?? null,
                    cdItem: item?.cdItem ?? null,
                    tpItem: item?.tpItem ?? null,
                }

                this.filter = ''
                this.page = 0
                this.rows = []
                this.qtdRecords = 0
                this.qtdTotalItem = 0
                this.qtdRegistros = 0

                if (!this.itemInfo.idItem) {
                    avisoToast('Item inválido para abrir detalhes.', 'warning')
                    return
                }

                this.getDados().then(() => {
                    this.bsModal?.show?.()
                })
            },

            async getDados() {
                this.loading = true
                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItemDetalhadoPorItem`, {
                        params: {
                            idItem: this.itemInfo.idItem,
                            idRegistroNecessidade: this.idRegistroNecessidadeFiltro || null,
                            index: this.page,
                            take: this.pageSize,
                        }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar detalhes do item!', 'warning')
                        return
                    }

                    const grid = res.data.data
                    const rows = grid?.rows || []

                    this.rows = rows.map(x => x.registroNecessidadeItem || x)
                    this.qtdRecords = Number(grid?.qtdRecords || 0)

                    const first = this.rows[0]
                    this.qtdTotalItem = Number(first?.qtdTotalItem || 0)

                    const uniq = new Set(this.rows.map(x => x.idRegistroNecessidade))
                    this.qtdRegistros = uniq.size
                } catch (err) {
                    console.error(err)
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar detalhes do item!')
                } finally {
                    this.loading = false
                }
            },

            previousPage() {
                if (this.page > 0 && !this.loading) {
                    this.page--
                    this.getDados()
                }
            },

            nextPage() {
                if (this.temProximaPagina && !this.loading) {
                    this.page++
                    this.getDados()
                }
            },

            goToPage(p) {
                if (p !== this.page && !this.loading) {
                    this.page = p
                    this.getDados()
                }
            },

            formatarData(dataISO) {
                if (!dataISO) return ''
                const d = new Date(dataISO)
                return d.toLocaleDateString('pt-BR')
            },

            formatarQtd(v) {
                if (v === null || v === undefined) return '0'
                try {
                    return Number(v).toLocaleString('pt-BR')
                } catch {
                    return String(v)
                }
            },
        },
    }
</script>

<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .btn-close-modern:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .btn-md {
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 24px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.16) 0%, rgba(59, 130, 246, 0.16) 100%);
        color: #0f766e;
        flex-shrink: 0;
    }

    .header-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .header-text p {
        margin: 0;
        color: #475569;
        font-size: 14px;
        max-width: 520px;
        line-height: 1.4;
    }

    .header-status {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .modal-modern-body {
        padding: 28px 32px 24px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .section-stack {
        display: flex;
        flex-direction: column;
        gap: 22px;
    }

    .section-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 18px;
        padding: 20px 22px;
        box-shadow: 0 12px 28px rgba(148, 163, 184, 0.15);
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .dependency-toolbar {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-radius: 16px;
        padding: 16px 18px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
    }

    .toolbar-text {
        color: #475569;
        font-size: 13px;
        max-width: 460px;
        line-height: 1.5;
    }

    .toolbar-actions {
        display: flex;
        align-items: center;
        gap: 14px;
        flex-wrap: wrap;
    }

    .modern-input .input-group-text {
        background: rgba(248, 250, 252, 0.9);
        border: 1px solid rgba(203, 213, 225, 0.7);
        border-right: none;
        border-radius: 12px 0 0 12px;
        color: #64748b;
    }

    .modern-input .form-control {
        border-radius: 0 12px 12px 0;
        border: 1px solid rgba(203, 213, 225, 0.7);
        padding: 10px 14px;
        font-size: 14px;
    }

    .total-chip {
        padding: 8px 14px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #bfdbfe;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #1e40af;
    }

    .table-wrapper {
        margin-top: 4px;
    }

    .modern-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

    .modern-table .custom-table thead {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .modern-table .custom-table th,
    .modern-table .custom-table td {
        padding: 14px 18px;
        border-bottom: 1px solid rgba(148, 163, 184, 0.16);
        font-size: 14px;
        color: #1e293b;
    }

    .modern-table .custom-table th {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 0.45px;
    }

    .modern-table .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.08);
    }

    .number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .pill {
        display: inline-flex;
        align-items: center;
        padding: 4px 12px;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
        border: 1px solid transparent;
    }

    .pill-ok {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border-color: rgba(16, 185, 129, 0.25);
    }

    .pill-warn {
        background: rgba(245, 158, 11, 0.12);
        color: #d97706;
        border-color: rgba(245, 158, 11, 0.25);
    }

    .pill-off {
        background: rgba(239, 68, 68, 0.12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, 0.25);
    }

    .empty-state {
        padding: 32px 24px;
        text-align: center;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #94a3b8;
    }

    .empty-title {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .custom-table-footer {
        border: 1px solid rgba(226, 232, 240, 0.8);
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        font-size: 14px;
        font-weight: 600;
    }

    .pagination-controls {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
        align-items: center;
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 38px;
        height: 38px;
        padding: 0 10px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #ffffff;
    }

    .page-box:hover:not(.disabled) {
        background: #f3f4f6;
        border-color: #2563eb;
    }

    .page-box.disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed;
    }

    .page-box.page-box-active {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        border-color: transparent;
    }

    .navigation-symbol {
        font-size: 1.1em;
    }

    .footer-total {
        color: #475569;
    }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .footer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 20px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
        color: #ffffff;
    }

    .modern-btn-secondary:hover {
        opacity: 0.9;
        transform: translateY(-1px);
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.15em;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }

        .modal-modern-header {
            flex-wrap: wrap;
        }

        .header-status {
            width: 100%;
        }

        .dependency-toolbar {
            flex-direction: column;
            align-items: stretch;
        }

        .toolbar-actions {
            justify-content: stretch;
        }

        .custom-table-footer {
            flex-direction: column;
            align-items: center;
        }
    }

    /* Dark mode */
    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .header-icon {
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.26) 0%, rgba(59, 130, 246, 0.26) 100%);
        color: #34d399;
    }

    [data-bs-theme="dark"] .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .section-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 41, 59, 0.94) 100%);
        border-color: rgba(71, 85, 105, 0.55);
    }

    [data-bs-theme="dark"] .dependency-toolbar {
        background: rgba(15, 23, 42, 0.86);
        border-color: rgba(71, 85, 105, 0.6);
    }

    [data-bs-theme="dark"] .toolbar-text {
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modern-input .input-group-text {
        background: rgba(15, 23, 42, 0.82);
        border-color: rgba(71, 85, 105, 0.6);
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-input .form-control {
        background: rgba(15, 23, 42, 0.82);
        border-color: rgba(71, 85, 105, 0.6);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .total-chip {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .modern-table .custom-table {
        border-color: rgba(71, 85, 105, 0.6);
    }

    [data-bs-theme="dark"] .modern-table .custom-table thead {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    }

    [data-bs-theme="dark"] .modern-table .custom-table th,
    [data-bs-theme="dark"] .modern-table .custom-table td {
        color: #e2e8f0;
        border-color: rgba(71, 85, 105, 0.5);
    }

    [data-bs-theme="dark"] .modern-table .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.18);
    }

    [data-bs-theme="dark"] .number-badge {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        border-color: rgba(71, 85, 105, 0.6);
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .pill-ok {
        background: rgba(16, 185, 129, 0.22);
        color: #34d399;
    }

    [data-bs-theme="dark"] .pill-warn {
        background: rgba(245, 158, 11, 0.22);
        color: #fbbf24;
    }

    [data-bs-theme="dark"] .pill-off {
        background: rgba(239, 68, 68, 0.22);
        color: #f87171;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: rgba(71, 85, 105, 0.6);
    }

    [data-bs-theme="dark"] .footer-total {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .page-box {
        background: #1e293b;
        border-color: #334155;
    }

    [data-bs-theme="dark"] .page-box:hover:not(.disabled) {
        background: #334155;
        border-color: #3b82f6;
    }

    [data-bs-theme="dark"] .page-box.page-box-active {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }
</style>
